import { loadGifts, loadGift, loadGiftRecipients } from '../common/api';

const gifts = {
    name: 'gifts',
    state: { 
        names: [], 
        current: {
            details: {},
            recips: []
        },
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.gid
            }
        },
        cdcInsert: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.gid]: { ...payload.cdc }
                }
            }
        },
        cdcInsertRecip: ( state, payload ) => {
            const [ gid, oid ] = payload.gid.split( '#' );
            const recip = [ payload.cdc ];
            
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [gid]: { 
                        ...state.byId[gid],
                        recips: recip
                    }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.gid]: {
                        ...state.byId[payload.gid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.gid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        loadedGifts: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        },
        loadedGift: ( state, payload ) => {
            return {
                ...state,
                current: {
                    ...state.current,
                    details: payload
                }
            }
        },
        loadedGiftRecips: ( state, payload ) => {
            return {
                ...state,
                current: {
                    ...state.current,
                    recips: payload
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadGift( { aid, uid, gid } ) {
            const g = await loadGift( aid, uid, gid );
            dispatch.gifts.loadedGift( g );
        },
        async loadGiftRecipients( { aid, uid, gid } ) {
            const e = await loadGiftRecipients( aid, uid, gid );
            dispatch.gifts.loadedGiftRecips( e );
        },
        async loadGifts( { aid, uid } ) {
            const list = await loadGifts( aid, uid );
            let byId = {};
            list.forEach( g => byId[g.gid] = g );
            dispatch.gifts.loadedGifts( byId );
        },
        insert( { gid, cdc } ) {
            const recip = gid.match( '#' );
            if ( recip ) {
                dispatch.gifts.cdcInsertRecip( { gid, cdc } );
            } else {
                dispatch.gifts.cdcInsert( { gid, cdc } );
            }
        },
        modify( { gid, cdc } ) {
            dispatch.gifts.cdcModify( { gid, cdc } );
        },
        remove( { gid } ) {
            dispatch.gifts.cdcRemove( { gid } );
        },
        setCurrent( { gid } ) {
            dispatch.gifts.setCurrentId( { gid } );
        }
    } )
}

export default gifts;